(function () {
  const API_URL = "https://script.google.com/macros/s/AKfycbzkr2w0IJDJ3wBOgWMPH3cJrwa4NEF2wGi9a1QNuweSklWmjLPU9-ZBIDTrwYzL6eID/exec";
  const CUT_OPTIONS = ["Yuvarlak", "Oval", "Radiant", "Emerald", "Markiz", "Damla", "Princess", "Cushion"];
  const COLOR_OPTIONS = ["D", "E", "F"];
  const CLARITY_OPTIONS = ["VVS1", "VVS2", "VS1", "VS2"];
  const QUALITY_OPTIONS_ALL = [
    { label: "LOW TIER (alt grup)", value: "Low Tier", showFor: "all" },
    { label: "Median", value: "Median", showFor: "all" },
    { label: "A (Fancy cuts)", value: "A", showFor: "fancy" },
    { label: "H&A Round", value: "H&A (Sadece Yuvarlak)", showFor: "round" },
    { label: "Lab Plus Premium", value: "Lab Plus", showFor: "all" }
  ];

  let apiRows = [];
  let rowCounter = 0;

  function $(id) {
    return document.getElementById(id);
  }

  function normalizeText(value) {
    return String(value || "").trim();
  }

  function formatUSD(value) {
    return "$" + Math.round(Number(value || 0)).toLocaleString("en-US");
  }

  function formatUSD2(value) {
    return "$" + Number(value || 0).toFixed(2);
  }

  function clampDiscount(value) {
    const n = Number(value || 0);
    if (Number.isNaN(n)) return 0;
    return Math.min(100, Math.max(0, n));
  }

  function getDiscountRate() {
    const input = $("bk-discount-rate");
    if (!input) return 0;
    return clampDiscount(input.value);
  }

  function getBucketByCarat(carat) {
    const match = apiRows.find(function (r) {
      const min = Number(r.carat_min);
      const max = Number(r.carat_max);
      return carat >= min && carat <= max;
    });
    return match ? normalizeText(match.bucket_label) : null;
  }

  function getAllowedQualityOptions(cutLabel) {
    const isRound = normalizeText(cutLabel) === "Yuvarlak";
    return QUALITY_OPTIONS_ALL.filter(function (q) {
      if (q.showFor === "all") return true;
      if (q.showFor === "round") return isRound;
      if (q.showFor === "fancy") return !isRound;
      return false;
    });
  }

  function createSelect(options, className) {
    const select = document.createElement("select");
    if (className) select.className = className;

    options.forEach(function (opt) {
      const option = document.createElement("option");
      if (typeof opt === "string") {
        option.value = opt;
        option.textContent = opt;
      } else {
        option.value = opt.value;
        option.textContent = opt.label;
      }
      select.appendChild(option);
    });

    return select;
  }

  function updateQualitySelectForCut(rowEl) {
    const cutSelect = rowEl.querySelector(".bk-row-cut");
    const qualitySelect = rowEl.querySelector(".bk-row-quality");
    const currentValue = qualitySelect.value;
    const allowed = getAllowedQualityOptions(cutSelect.value);

    qualitySelect.innerHTML = "";
    allowed.forEach(function (opt) {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.label;
      qualitySelect.appendChild(option);
    });

    const stillExists = allowed.some(function (opt) {
      return opt.value === currentValue;
    });

    qualitySelect.value = stillExists ? currentValue : allowed[0].value;
  }

  function lookupPricePerCt(rowEl) {
    const quality = normalizeText(rowEl.querySelector(".bk-row-quality").value);
    const color = normalizeText(rowEl.querySelector(".bk-row-color").value);
    const clarity = normalizeText(rowEl.querySelector(".bk-row-clarity").value);
    const carat = Number(rowEl.querySelector(".bk-row-carat").value || 0);

    if (!carat || carat < 0.5) return { ppc: 0, total: 0, bucket: null };

    const bucket = getBucketByCarat(carat);
    if (!bucket) return { ppc: 0, total: 0, bucket: null };

    const match = apiRows.find(function (r) {
      return (
        normalizeText(r.bucket_label) === bucket &&
        normalizeText(r.quality_tier_key) === quality &&
        normalizeText(r.color) === color &&
        normalizeText(r.clarity) === clarity
      );
    });

    if (!match) return { ppc: 0, total: 0, bucket: bucket };

    const ppc = Number(match.final_usd_per_ct || 0);
    const total = ppc * carat;
    return { ppc: ppc, total: total, bucket: bucket };
  }

  function recalcRow(rowEl) {
    updateQualitySelectForCut(rowEl);
    const result = lookupPricePerCt(rowEl);
    rowEl.querySelector(".bk-row-ppc").value = result.ppc > 0 ? Number(result.ppc).toFixed(2) : "";
    rowEl.querySelector(".bk-row-total").value = result.total > 0 ? Number(result.total).toFixed(2) : "";
    rowEl.dataset.bucket = result.bucket || "";
    recalcTotals();
  }

  function recalcTotals() {
    const rows = Array.from(document.querySelectorAll("#bk-order-tbody tr"));
    let pieces = 0;
    let totalCarats = 0;
    let grossTotalUSD = 0;

    rows.forEach(function (row) {
      const carat = Number(row.querySelector(".bk-row-carat").value || 0);
      const total = Number(row.querySelector(".bk-row-total").value || 0);
      const ppc = Number(row.querySelector(".bk-row-ppc").value || 0);

      if (carat > 0 && ppc > 0) {
        pieces += 1;
        totalCarats += carat;
        grossTotalUSD += total;
      }
    });

    const discountRate = getDiscountRate();
    const discountMultiplier = 1 - (discountRate / 100);
    const discountedTotalUSD = grossTotalUSD * discountMultiplier;

    const grossAvgUsdCt = totalCarats > 0 ? (grossTotalUSD / totalCarats) : 0;
    const discountedAvgUsdCt = totalCarats > 0 ? (discountedTotalUSD / totalCarats) : 0;

    $("bk-total-pieces").textContent = String(pieces);
    $("bk-total-carats").textContent = totalCarats.toFixed(2);

    $("bk-gross-total-usd").textContent = formatUSD(grossTotalUSD);
    $("bk-gross-avg-usd-ct").textContent = formatUSD2(grossAvgUsdCt);

    $("bk-discount-display").textContent = discountRate.toFixed(2).replace(/\.00$/, "") + "%";

    $("bk-total-usd").textContent = formatUSD(discountedTotalUSD);
    $("bk-avg-usd-ct").textContent = formatUSD2(discountedAvgUsdCt);
  }

  function isRowFilledForCopy(rowEl) {
    const quality = normalizeText(rowEl.querySelector(".bk-row-quality").value);
    const cut = normalizeText(rowEl.querySelector(".bk-row-cut").value);
    const carat = Number(rowEl.querySelector(".bk-row-carat").value || 0);
    const color = normalizeText(rowEl.querySelector(".bk-row-color").value);
    const clarity = normalizeText(rowEl.querySelector(".bk-row-clarity").value);

    return !!quality && !!cut && carat > 0 && !!color && !!clarity;
  }

  function copyRowData(rowEl) {
    if (!isRowFilledForCopy(rowEl)) {
      alert("Önce satırı doldurun, sonra çoğaltın.");
      return;
    }

    const data = {
      quality: rowEl.querySelector(".bk-row-quality").value,
      cut: rowEl.querySelector(".bk-row-cut").value,
      carat: rowEl.querySelector(".bk-row-carat").value,
      color: rowEl.querySelector(".bk-row-color").value,
      clarity: rowEl.querySelector(".bk-row-clarity").value
    };

    addRow(data);
  }

  function addRow(prefill) {
    rowCounter += 1;
    const tr = document.createElement("tr");

    const tdNo = document.createElement("td");
    tdNo.className = "bk-col-small";
    tdNo.textContent = String(rowCounter);

    const tdQuality = document.createElement("td");
    const initialCut = prefill && prefill.cut ? prefill.cut : "Yuvarlak";
    const qualitySelect = createSelect(getAllowedQualityOptions(initialCut), "bk-row-quality");
    tdQuality.appendChild(qualitySelect);

    const tdCut = document.createElement("td");
    const cutSelect = createSelect(CUT_OPTIONS, "bk-row-cut");
    tdCut.appendChild(cutSelect);

    const tdCarat = document.createElement("td");
    tdCarat.className = "bk-col-carat";
    const caratInput = document.createElement("input");
    caratInput.type = "number";
    caratInput.step = "0.01";
    caratInput.min = "0.50";
    caratInput.placeholder = "2.30";
    caratInput.className = "bk-row-carat";
    tdCarat.appendChild(caratInput);

    const tdColor = document.createElement("td");
    const colorSelect = createSelect(COLOR_OPTIONS, "bk-row-color");
    tdColor.appendChild(colorSelect);

    const tdClarity = document.createElement("td");
    const claritySelect = createSelect(CLARITY_OPTIONS, "bk-row-clarity");
    tdClarity.appendChild(claritySelect);

    const tdPpc = document.createElement("td");
    tdPpc.className = "bk-col-price";
    const ppcInput = document.createElement("input");
    ppcInput.type = "number";
    ppcInput.step = "0.01";
    ppcInput.readOnly = true;
    ppcInput.className = "bk-row-ppc";
    tdPpc.appendChild(ppcInput);

    const tdTotal = document.createElement("td");
    tdTotal.className = "bk-col-total";
    const totalInput = document.createElement("input");
    totalInput.type = "number";
    totalInput.step = "0.01";
    totalInput.readOnly = true;
    totalInput.className = "bk-row-total";
    tdTotal.appendChild(totalInput);

    const tdRemove = document.createElement("td");
    tdRemove.className = "bk-col-remove";
    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "bk-btn-danger";
    removeBtn.textContent = "Sil";
    tdRemove.appendChild(removeBtn);

    const tdCopy = document.createElement("td");
    tdCopy.className = "bk-col-copy";
    const copyBtn = document.createElement("button");
    copyBtn.type = "button";
    copyBtn.className = "bk-btn-copy";
    copyBtn.textContent = "Çoğalt";
    tdCopy.appendChild(copyBtn);

    tr.append(tdNo, tdQuality, tdCut, tdCarat, tdColor, tdClarity, tdPpc, tdTotal, tdRemove, tdCopy);

    [qualitySelect, cutSelect, caratInput, colorSelect, claritySelect].forEach(function (el) {
      el.addEventListener("change", function () { recalcRow(tr); });
      el.addEventListener("input", function () { recalcRow(tr); });
    });

    removeBtn.addEventListener("click", function () {
      tr.remove();
      renumberRows();
      recalcTotals();
    });

    copyBtn.addEventListener("click", function () {
      copyRowData(tr);
    });

    $("bk-order-tbody").appendChild(tr);

    if (prefill) {
      cutSelect.value = prefill.cut || "Yuvarlak";
      updateQualitySelectForCut(tr);
      qualitySelect.value = prefill.quality || qualitySelect.value;
      caratInput.value = prefill.carat || "";
      colorSelect.value = prefill.color || "D";
      claritySelect.value = prefill.clarity || "VS1";
    }

    recalcRow(tr);
  }

  function renumberRows() {
    const rows = Array.from(document.querySelectorAll("#bk-order-tbody tr"));
    rows.forEach(function (row, index) {
      row.querySelector("td").textContent = String(index + 1);
    });
  }

  function addRows(count) {
    for (let i = 0; i < count; i += 1) addRow();
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildPrintableHtml() {
    const customerName = $("bk-customer-name").value || "-";
    const date = $("bk-order-date").value || "-";
    const orderRef = $("bk-order-ref").value || "-";
    const notes = $("bk-order-notes").value || "-";
    const discountRate = getDiscountRate();

    const rows = Array.from(document.querySelectorAll("#bk-order-tbody tr"))
      .map(function (row) {
        const qualityText = row.querySelector(".bk-row-quality").selectedOptions[0]?.textContent || "";
        const cut = row.querySelector(".bk-row-cut").value || "";
        const carat = row.querySelector(".bk-row-carat").value || "";
        const color = row.querySelector(".bk-row-color").value || "";
        const clarity = row.querySelector(".bk-row-clarity").value || "";
        const ppc = row.querySelector(".bk-row-ppc").value || "";
        const total = row.querySelector(".bk-row-total").value || "";
        if (!carat || !ppc) return null;
        return "<tr><td>" + escapeHtml(qualityText) + "</td><td>" + escapeHtml(cut) + "</td><td>" + escapeHtml(carat) + "</td><td>" + escapeHtml(color) + "</td><td>" + escapeHtml(clarity) + "</td><td>$" + escapeHtml(ppc) + "</td><td>$" + escapeHtml(total) + "</td></tr>";
      })
      .filter(Boolean)
      .join("");

    const totalPieces = $("bk-total-pieces").textContent || "0";
    const totalCarats = $("bk-total-carats").textContent || "0.00";
    const grossTotalUsd = $("bk-gross-total-usd").textContent || "$0";
    const grossAvgUsdCt = $("bk-gross-avg-usd-ct").textContent || "$0";
    const discountedTotalUsd = $("bk-total-usd").textContent || "$0";
    const discountedAvgUsdCt = $("bk-avg-usd-ct").textContent || "$0";

    return "<!doctype html><html><head><meta charset='utf-8'><title>B2B Pırlanta Sipariş Listesi</title><style>body{font-family:Arial,Helvetica,sans-serif;color:#111;padding:28px}h1{font-size:24px;margin:0 0 18px}.meta{margin-bottom:18px;line-height:1.8}table{width:100%;border-collapse:collapse;margin-top:12px}th,td{border:1px solid #ddd;padding:8px;font-size:13px;text-align:left}th{background:#f7f7f7}.summary{margin-top:18px;line-height:1.9}.notes{margin-top:18px;white-space:pre-wrap}</style></head><body><h1>B2B Pırlanta Sipariş Listesi</h1><div class='meta'><strong>Customer Name:</strong> " + escapeHtml(customerName) + "<br><strong>Discount %:</strong> " + escapeHtml(discountRate) + "%<br><strong>Date:</strong> " + escapeHtml(date) + "<br><strong>Order Ref:</strong> " + escapeHtml(orderRef) + "</div><table><thead><tr><th>Kalite</th><th>Kesim</th><th>Carats</th><th>Color</th><th>Clarity</th><th>Price/Ct</th><th>Total</th></tr></thead><tbody>" + (rows || "<tr><td colspan='7'>Kayıt yok</td></tr>") + "</tbody></table><div class='summary'><strong>Total Pieces:</strong> " + escapeHtml(totalPieces) + "<br><strong>Total Carats:</strong> " + escapeHtml(totalCarats) + "<br><strong>Gross Total USD:</strong> " + escapeHtml(grossTotalUsd) + "<br><strong>Gross Average $/Ct:</strong> " + escapeHtml(grossAvgUsdCt) + "<br><strong>Discounted Total USD:</strong> " + escapeHtml(discountedTotalUsd) + "<br><strong>Discounted Average $/Ct:</strong> " + escapeHtml(discountedAvgUsdCt) + "</div><div class='notes'><strong>Notes:</strong><br>" + escapeHtml(notes) + "</div></body></html>";
  }

  function openPdfPrint() {
    const html = buildPrintableHtml();
    const win = window.open("", "_blank");
    if (!win) return;
    win.document.open();
    win.document.write(html);
    win.document.close();
    setTimeout(function () {
      win.focus();
      win.print();
    }, 400);
  }

  async function loadRapData() {
    const status = $("bk-order-status");
    try {
      const res = await fetch(API_URL, { method: "GET" });
      const json = await res.json();
      apiRows = Array.isArray(json.items) ? json.items : [];
      if (!apiRows.length) {
        status.textContent = "RAP verisi bulundu ancak okunamadı.";
        return;
      }
      status.textContent = "RAP verisi yüklendi. Sipariş listesi hazır.";
      addRows(5);
    } catch (err) {
      console.error("RAP API fetch error:", err);
      status.textContent = "RAP verisi yüklenemedi. Web app URL veya deployment ayarını kontrol edin.";
    }
  }

  function init() {
    if (!$("bk-order-tbody")) return;

    $("bk-add-rows-btn").addEventListener("click", function () {
      addRows(5);
    });

    $("bk-pdf-btn").addEventListener("click", function () {
      openPdfPrint();
    });

    $("bk-discount-rate").addEventListener("input", function () {
      recalcTotals();
    });

    $("bk-discount-rate").addEventListener("change", function () {
      recalcTotals();
    });

    $("bk-order-date").value = new Date().toISOString().slice(0, 10);
    loadRapData();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();